/* eslint-disable camelcase */
export enum ImminenceTypes {
  GET_DADOS_IMMINENCE_REQUEST = '@imminence/GET_DADOS_IMMINENCE_REQUEST',
  GET_DADOS_IMMINENCE_SUCCESS = '@imminence/GET_DADOS_IMMINENCE_SUCCESS',
  GET_DADOS_IMMINENCE_FAILURE = '@imminence/GET_DADOS_IMMINENCE_FAILURE',
  SEARCH_IMMINENCE_REQUEST = '@imminence/SEARCH_IMMINENCE_REQUEST',
  SEARCH_IMMINENCE_SUCCESS = '@imminence/SEARCH_IMMINENCE_SUCCESS',
  SEARCH_IMMINENCE_FAILURE = '@imminence/SEARCH_IMMINENCE_FAILURE',
  CREATE_COMMENT_REQUEST = '@imminence/CREATE_COMMENT_REQUEST',
  CREATE_COMMENT_SUCCESS = '@imminence/CREATE_COMMENT_SUCCESS',
  CREATE_COMMENT_FAILURE = '@imminence/CREATE_COMMENT_FAILURE',
  GET_COMMENTS_REQUEST = '@imminence/GET_COMMENTS_REQUEST',
  GET_COMMENTS_SUCCESS = '@imminence/GET_COMMENTS_SUCCESS',
  GET_COMMENTS_FAILURE = '@imminence/GET_COMMENTS_FAILURE',
  DESTROY_COMMENT_REQUEST = '@imminence/DESTROY_COMMENT_REQUEST',
  DESTROY_COMMENT_SUCCESS = '@imminence/DESTROY_COMMENT_SUCCESS',
  DESTROY_COMMENT_FAILURE = '@imminence/DESTROY_COMMENT_FAILURE',
  CREATE_BIDDING_FAVORITE_REQUEST = '@imminence/CREATE_BIDDING_FAVORITE_REQUEST',
  CREATE_BIDDING_FAVORITE_SUCCESS = '@imminence/CREATE_BIDDING_FAVORITE_SUCCESS',
  CREATE_BIDDING_FAVORITE_FAILURE = '@imminence/CREATE_BIDDING_FAVORITE_FAILURE',
  DESTROY_BIDDING_FAVORITE_REQUEST = '@imminence/DESTROY_BIDDING_FAVORITE_REQUEST',
  DESTROY_BIDDING_FAVORITE_SUCCESS = '@imminence/DESTROY_BIDDING_FAVORITE_SUCCESS',
  DESTROY_BIDDING_FAVORITE_FAILURE = '@imminence/DESTROY_BIDDING_FAVORITE_FAILURE',
  CREATE_BIDDING_MANAGED_REQUEST = '@imminence/CREATE_BIDDING_MANAGED_REQUEST',
  CREATE_BIDDING_MANAGED_SUCCESS = '@imminence/CREATE_BIDDING_MANAGED_SUCCESS',
  CREATE_BIDDING_MANAGED_FAILURE = '@imminence/CREATE_BIDDING_MANAGED_FAILURE',
  DESTROY_BIDDING_MANAGED_REQUEST = '@imminence/DESTROY_BIDDING_MANAGED_REQUEST',
  DESTROY_BIDDING_MANAGED_SUCCESS = '@imminence/DESTROY_BIDDING_MANAGED_SUCCESS',
  DESTROY_BIDDING_MANAGED_FAILURE = '@imminence/DESTROY_BIDDING_MANAGED_FAILURE',

  UPDATE_CURRENT_PAGE = '@imminence/UPDATE_CURRENT_PAGE',
  SHOW_PAGE = '@imminence/SHOW_PAGE',
}

export interface EditalTypes {
  filename: string;
  url: string;
}

export interface CommentDataTypes {
  contact_client: {
    id: number;
    nome: string;
  };
  created_at: string;
  id: number;
  message: string;
}

export interface ObjectImminenceTypes {
  _source: {
    atividade: string;
    created: string;
    data_validade: string;
    datahora_abertura: string | null;
    datahora_documento: string | null;
    datahora_prazo: string | null;
    edital: string;
    edital_preco: number;
    edital_status_id: number;
    edital_tem: boolean;
    fonte_id: number;
    id: number;
    favorited: boolean;
    edicts: Array<EditalTypes>;
    managed: boolean;
    comments: Array<CommentDataTypes>;
    favorited_by: Array<string>;
  };
}

export interface ImminencesTypes {
  index: string;
  _id: number;
  score: string;
  _source: Array<ObjectImminenceTypes>;
  currentPage: number;
  postsPerPage: number;
  total_entries: number;
  total_imminence: {
    has_low_competition: number;
    has_imminence: number;
    has_desert: number;
  };
  view_panel: string;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface SearchRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface CommentsRequestState {
  get_comments: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  create_comment: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  destroy_comment: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface IndividualCommentRequestState {
  [key: string]: CommentsRequestState;
}

export interface CommentTypes {
  [key: string]: Array<CommentDataTypes>;
}

export interface ImminenceState {
  get_imminence: ImminencesTypes;
  readonly request: RequestState;
  readonly search_imminence: SearchRequestState;
  readonly comments: CommentTypes;
  readonly comments_imminence_request: IndividualCommentRequestState;
  readonly destroy_imminence_managed_request: RequestState;
}
